import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { ICmsNotificationService } from './../../../ui/notification/icms-notification.service';
import { ConfigResource } from '@df/catalog/config/config.resource';

declare module '@df/core/app' {
    interface App {
        iCmsConfigSaveService: ICmsConfigSaveService;
    }
}
@Injectable()
export class ICmsConfigSaveService {
    constructor(app: App, private configResource: ConfigResource, private iCmsNotificationService: ICmsNotificationService) {
        app.iCmsConfigSaveService = this;
    }

    async save(model: ICmsConfig, options?: { noConfirm?: boolean }): Promise<void> {
        try {
            await (this.configResource as any as ICmsConfigResource).save(model);
        } catch (err) {
            this.iCmsNotificationService.add({
                title: 'Failed to save configuration',
                type: 'error',
                copy: this.iCmsNotificationService.toErrorMsg(err),
                duration: 0
            });
            throw err;
        }
        if (!options?.noConfirm) {
            this.iCmsNotificationService.add({
                title: 'Configuration entry saved',
                type: 'success'
            });
        }
    }
}
